import { ApiBaseBack } from "../../back/api-base-back";
import { TemplatesResponse } from '../../../models/api/sift/back/api-templates';

export class ApiGetTemplates extends ApiBaseBack<TemplatesResponse> {
  constructor(param: {
    itemId: string,
    edgeDtempId?: string,
    directFlg?: number,
    printDateFlg?: boolean,
  }) {
    super(
      'POST',
      '/api/v1/centerTemplates',
      'JSON',
      param,
    );
  }
}
